<script setup>
import { defineEmits, defineProps } from 'vue'

import { Dialog } from '@progress/kendo-vue-dialogs';
import { Button } from '@progress/kendo-vue-buttons';

defineProps({
  text: {
    type: String,
    required: false,
    default: 'Вы действительно хотите удалить?'
  }
})

const emits = defineEmits(['accept', 'cancel']);

const onCancel = () => {
  emits('cancel' );
}

const onAccept = () => {
  emits('accept' );
}
</script>

<template>
  <Dialog :width="500" @save="onAccept" @cancel="onCancel">
    <div class="modal-delete">
      <div class="modal-delete__content">
        <p class="modal-delete__description">
          {{ text }}
        </p>
      </div>

      <div class="modal-delete__footer custom-modal-footer">
        <Button @click="onCancel">Отмена</Button>
        <Button :theme-color="'primary'" @click="onAccept">Удалить</Button>
      </div>
    </div>
  </Dialog>
</template>

<style scoped lang="scss">
.modal-delete {
  &__description {
    margin: 2rem 0;
    text-align: center;
    font-size: 18px;
    font-weight: 700
  }
}
</style>